<div class="schema-test-row mb-4">
  <div>Column</div>
  <div>Type</div>
  <div>Nullable</div>
  <div>Required</div>
  <div></div>
</div>
<div
  class="schema-test-row"
  *ngFor="let formGroup of schemaForm.controls.schema.controls; trackBy: trackByFn; let index = index"
>
  <div>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Column</mat-label>
      <input type="text" matInput placeholder="Column" [formControl]="formGroup.controls.column" autocomplete="off" />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Type</mat-label>
      <mat-select [formControl]="formGroup.controls.type">
        <mat-option
          *ngFor="let columnType of state.columnTypes; trackBy: columnTypesTrackByFn"
          [value]="columnType.columnType"
        >
          <y42-column-type-icon *ngIf="columnType.columnType" [type]="columnType.columnType"></y42-column-type-icon>
          {{ columnType.name }}
        </mat-option>
        <mat-select-trigger>
          <y42-column-type-icon [type]="formGroup.controls.type.value"></y42-column-type-icon>
          {{ columnTypeEnumToName[formGroup.controls.type.value] || formGroup.controls.type.value }}
        </mat-select-trigger>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-slide-toggle
      color="primary"
      [formControl]="formGroup.controls.allow_null_values"
      class="mt-5"
    ></mat-slide-toggle>
  </div>
  <div>
    <mat-slide-toggle color="primary" [formControl]="formGroup.controls.required" class="mt-5"></mat-slide-toggle>
  </div>
  <div>
    <button mat-icon-button (click)="deleteSchemaRow(index)" class="mt-3">
      <fa-icon [icon]="['fal', 'trash-can']"></fa-icon>
    </button>
  </div>
</div>
<div class="schema-test-row">
  <div>
    <mat-form-field appearance="outline" class="w-full" (click)="addSchemaRow()">
      <mat-label>Column Name</mat-label>
      <input type="text" matInput placeholder="Column" autocomplete="off" [disabled]="true" />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="w-full" (click)="addSchemaRow()">
      <mat-label>Data Type</mat-label>
      <mat-select [disabled]="true">
        <mat-option>-</mat-option>
        <mat-select-trigger> Data type </mat-select-trigger>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-slide-toggle color="primary" [disabled]="true" class="mt-5" [checked]="false"></mat-slide-toggle>
  </div>
  <div>
    <mat-slide-toggle color="primary" [disabled]="true" class="mt-5" [checked]="false"></mat-slide-toggle>
  </div>
  <div>
    <button mat-icon-button (click)="addSchemaRow()" class="mt-3">
      <fa-icon [icon]="['fal', 'plus']"></fa-icon>
    </button>
  </div>
</div>

<div class="mt-3">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Allow New Columns</mat-label>
    <mat-select [formControl]="schemaForm.controls.allowNewColumns">
      <mat-option [value]="true"><span class="text-green-700">TRUE</span></mat-option>
      <mat-option [value]="false"><span class="text-red-700">FALSE</span></mat-option>
      <mat-select-trigger>
        <span class="text-green-700" *ngIf="schemaForm.controls.allowNewColumns.value">TRUE</span>
        <span class="text-red-700" *ngIf="!schemaForm.controls.allowNewColumns.value">FALSE</span>
      </mat-select-trigger>
    </mat-select>
  </mat-form-field>
</div>
